<template>
  <div v-if="bodyStyles && bodyStyles.length" class="row">
    <div v-for="(item, index) in bodyStyles" :key="index" class="col">
      <div
        class="body_style_card bg-white custom_box_shadow text-center cursor_pointer mb-2 p-3 py-4   align-items-center"
        :style="[index === isChecked ? { border: '1px solid' + primaryColor } : { border: '1px solid #fff' }]"
        :class="{ disabledContent: !isLastIndex }" @click.once="eachBodyStyle(item, index)">
        <div class="text-center">
          <!-- <i v-if="index === isChecked" class="primaryicon-tick-icon" :style="{ color: primaryColor }" /> -->
          <!-- <i class="primaryicon-car-empty-body" /> -->
          <!-- <img :src="'../Icons/' + item.iconName + '.svg'" alt="" class="img-fluid" /> -->
          <component :is="item.iconName" />
        </div>
        <div class="col-12 mt-2">
          <p class="mb-0 _theme_font_bold">{{ item.name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ChatWidgetService } from '../../../../Services/ChatWidgetService/ChatWidgetService';
import Convertible from '../Icons/Convertible.vue';
import Coupe from '../Icons/Coupe.vue';
import Electric from '../Icons/Electric.vue';
import Hatchback from '../Icons/Hatchback.vue';
import Hybrid from '../Icons/Hybrid.vue';
import MPV from '../Icons/MPV.vue';
import Other from '../Icons/Other.vue';
import Sedan from '../Icons/Sedan.vue';
import SUV from '../Icons/SUV.vue';
import Truck from '../Icons/Truck.vue';
import Van from '../Icons/Van.vue';
import Wagon from '../Icons/Wagon.vue';

// import { ChatWidgetService } from '../../Services/ChatWidgetService/ChatWidgetService';
// import { mapState } from 'vuex';
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['botResponse', 'isLastIndex', 'chatThemeSettings'],
  data() {
    return {
      bodyStyles: [],
      primaryColor: window.primaryColor,
      isChecked: null,
    }
  },
  // computed: {
  //   ...mapState({
  //     chatThemeSettings: (state) => {
  //       return state?.commonSettings?.chatThemeSettings;
  //     },
  //   }),
  // },
  mounted() {

    if (this.botResponse?.component?.values?.length) {
      this.bodyStyles = this.botResponse?.component?.values;
    }
    if (this.chatThemeSettings?.primeColor) {
      this.primaryColor = this.chatThemeSettings.primeColor;
    }

    console.log(this.botResponse, 'ccc')

  },
  methods: {
    eachBodyStyle(item, index) {
      // let specialObject = { TvmComponentRequest: item.name };
      ChatWidgetService.postTvmMessage(item.name, null, this.botResponse.submitFlow,
        this.botResponse.submitAction);
      this.isChecked = index;
    }
  },
  components: {
    Convertible,
    Coupe,
    Electric,
    Hatchback,
    Hybrid,
    MPV,
    Other,
    Sedan,
    SUV,
    Truck,
    Van,
    Wagon
  }
}
</script>
<style lang="less" scoped>
.body_style_card {
  border-radius: 10px;

  i {
    font-size: 30px;
  }

  &.disabledContent {
    pointer-events: none !important;
    opacity: 0.9 !important;
  }
}
</style>
